import * as React from "react"
import Layout from "../components/layout"
import Seo from "../components/seo"
import styled from "styled-components"
import BigSimpleBanner from "../banners/BigSimpleBanner"
import AppLines from "../animations/AppLine"

const PrivacyPage = () => (
  <Layout>
    <Seo title="Privacy" />
    <BannerWrapper>
      <BigSimpleBanner
        title="Chatsopon Deepateep Private Policy"
        desc="Chatsopon Deepateep's Private Policy describes how Chatsopon Deepateep's collects, uses, and shares your personal data. Applications developed by Chatsopon Deepateep will ask to use your personal information for certain features. Please take a moment to familiarize yourself with the private practices for your Apps via the heading below"
      />
      <BigSimpleBanner
        title="These applications do not collect your information."
        desc="Chatsopon Deepateep makes your privacy very important. Chatsopon Deepateep does not store any of your information to third parties without your permission. However, within the App there may be a section for you to send feedback to Chatsopon Deepateep without tracking you except your suggestion."
      >
        <AppLines />
      </BigSimpleBanner>
    </BannerWrapper>
  </Layout>
)

export default PrivacyPage

const BannerWrapper = styled.div`
  /* Auto Layout */

  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 15px;

  position: absolute;
  width: 100%;
  height: 100%;
  /* margin: 0 auto; */
`
